import {
  apiURL_admin_by_id,
  apiURL_admin_create,
  apiURL_admin_getAll,
  apiURL_admin_update,
  apiURL_admin_login,
  apiURL_admin_delete,
  apiURL_admin_update_user,
} from "../models/api-urls";
import axiosInstance from "../modules/axiosInstance";

class Service {
  signin = async (loginUser) => {
    try {
      const response = await axiosInstance.post(apiURL_admin_login, loginUser);
      return { user: response.data.admin, token: response.data.token };
    } catch (error) {
      console.error("Service - signin");
      throw new Error(error.response?.data?.message || "Login failed");
    }
  };

  getById = async (id) => {
    try {
      const response = await axiosInstance.get(`${apiURL_admin_by_id}/${id}`);
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || "get by id failed");
    }
  };

  getAll = async () => {
    try {
      const response = await axiosInstance.get(apiURL_admin_getAll);
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || "get all failed");
    }
  };

  create = async (admin) => {
    try {
      const response = await axiosInstance.post(apiURL_admin_create, { admin });
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Create failed");
    }
  };

  update = async (id, permissions) => {
    try {
      const endpoint = `${apiURL_admin_update}/${id}`;
      const response = await axiosInstance.put(endpoint, {
        manageUserPermissions: permissions,
      });
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || "update failed");
    }
  };

  updateUser = async (id, user) => {
    try {
      const endpoint = `${apiURL_admin_update_user}/${id}`;
      const response = await axiosInstance.put(endpoint, {
        user,
      });
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || "update user failed");
    }
  };

  deleteAdmin = async (id) => {
    try {
      const endpoint = `${apiURL_admin_delete}/${id}`;
      const response = await axiosInstance.delete(endpoint);
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || "deleted failed");
    }
  };
}

const AdminService = new Service();

export default AdminService;
